import { render, staticRenderFns } from "./AvatarImage.vue?vue&type=template&id=72c01f7f&"
import script from "./AvatarImage.vue?vue&type=script&lang=js&"
export * from "./AvatarImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports